/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Errors_For_EventInputs */

const en_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No errors found for this event.`)
};

const fr_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune erreur trouvee pour cet evenement.`)
};

const de_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Ereignis wurden keine Fehler gefunden.`)
};

const it_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun errore trovato per questo evento.`)
};

const ru_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибок для этого события не обнаружено.`)
};

const es_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron errores para este evento.`)
};

const zh_cn2_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此事件未发现任何错误。`)
};

const ja_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このイベントにエラーは見つかりませんでした。`)
};

const hi_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस इवेंट में कोई त्रुटि नहीं पाई गई।`)
};

const pt_pt2_error_nav_no_errors_for_event = /** @type {(inputs: Error_Nav_No_Errors_For_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum erro foi encontrado para este evento.`)
};

/**
* | output |
* | --- |
* | "No errors found for this event." |
*
* @param {Error_Nav_No_Errors_For_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_errors_for_event = /** @type {((inputs?: Error_Nav_No_Errors_For_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Errors_For_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_no_errors_for_event(inputs)
	if (locale === "de") return de_error_nav_no_errors_for_event(inputs)
	if (locale === "it") return it_error_nav_no_errors_for_event(inputs)
	if (locale === "ru") return ru_error_nav_no_errors_for_event(inputs)
	if (locale === "es") return es_error_nav_no_errors_for_event(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_no_errors_for_event(inputs)
	if (locale === "ja") return ja_error_nav_no_errors_for_event(inputs)
	if (locale === "hi") return hi_error_nav_no_errors_for_event(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_no_errors_for_event(inputs)
	return en_error_nav_no_errors_for_event(inputs)
});